<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/foreword">Foreword, by C. Donald Cook</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01"><b>1. B<span class="small">ASKETBALL</span>: I<span class="small">T</span>’<span class="small">S</span> C<span class="small">ONNECTICUT</span>’<span class="small">S</span> G<span class="small">AME</span>, T<span class="small">OO</span></b></a></p>
<p class="toc1"><span href="#/chapter02" title="Link target outside of Sample"><b>2. T<span class="small">HE</span> P<span class="small">LAYERS</span></b></span></p>
<p class="toc"><span href="#/chapter02#h1" title="Link target outside of Sample">Chuck Aleksinas</span></p>
<p class="toc"><span href="#/chapter02#h2" title="Link target outside of Sample">John Bagley</span></p>
<p class="toc"><span href="#/chapter02#h3" title="Link target outside of Sample">Vin Baker</span></p>
<p class="toc"><span href="#/chapter02#h4" title="Link target outside of Sample">Mike Branch</span></p>
<p class="toc"><span href="#/chapter02#h5" title="Link target outside of Sample">Alvin Clinkscales</span></p>
<p class="toc"><span href="#/chapter02#h6" title="Link target outside of Sample">Johnny Egan</span></p>
<p class="toc"><span href="#/chapter02#h7" title="Link target outside of Sample">Ed Goldstone</span></p>
<p class="toc"><span href="#/chapter02#h8" title="Link target outside of Sample">Tony Hanson</span></p>
<p class="toc"><span href="#/chapter02#h9" title="Link target outside of Sample">Walter Luckett</span></p>
<p class="toc"><span href="#/chapter02#h10" title="Link target outside of Sample">Wes Matthews</span></p>
<p class="toc"><span href="#/chapter02#h11" title="Link target outside of Sample">Calvin Murphy</span></p>
<p class="toc"><span href="#/chapter02#h12" title="Link target outside of Sample">Ralph Paolillo</span></p>
<p class="toc"><span href="#/chapter02#h13" title="Link target outside of Sample">Charles Smith</span></p>
<p class="toc"><span href="#/chapter02#h14" title="Link target outside of Sample">Chris Smith</span></p>
<p class="toc"><span href="#/chapter02#h15" title="Link target outside of Sample">Porky Vieira</span></p>
<p class="toc"><span href="#/chapter02#h16" title="Link target outside of Sample">John Williamson</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample"><b>3. T<span class="small">HE</span> C<span class="small">OACHES</span></b></span></p>
<p class="toc"><span href="#/chapter03#h1" title="Link target outside of Sample">Fred Barakat</span></p>
<p class="toc"><span href="#/chapter03#h2" title="Link target outside of Sample">Frank Crisafi</span></p>
<p class="toc"><span href="#/chapter03#h3" title="Link target outside of Sample">Bill Detrick</span></p>
<p class="toc"><span href="#/chapter03#h4" title="Link target outside of Sample">Dee Rowe</span></p>
<p class="toc"><span href="#/chapter03#h5" title="Link target outside of Sample">Harrison Taylor</span></p>
<p class="toc"><span href="#/chapter03#h6" title="Link target outside of Sample">Joe Vancisin</span></p>
<p class="toc"><span href="#/chapter03#h7" title="Link target outside of Sample">Red Verderame</span></p>
<p class="toc1"><span href="#/chapter04" title="Link target outside of Sample"><b>4. T<span class="small">HE</span> T<span class="small">EAMS</span></b></span></p>
<p class="toc"><span href="#/chapter04#h1" title="Link target outside of Sample">Bassick High School, 1988–89</span></p>
<p class="toc"><span href="#/chapter04#h2" title="Link target outside of Sample">University of Connecticut, 1975–76</span></p>
<p class="toc"><span href="#/chapter04#h3" title="Link target outside of Sample">Fairfield University, 1977–78</span></p>
<p class="toc"><span href="#/chapter04#h4" title="Link target outside of Sample">Roger Ludlowe High School, 1954–55</span></p>
<p class="toc"><span href="#/chapter04#h5" title="Link target outside of Sample">Sacred Heart University, 1985–86</span></p>
<p class="toc"><span href="#/chapter04#h6" title="Link target outside of Sample">Wilbur Cross High School, 1971–72</span></p>
<p class="toc1"><span href="#/chapter05" title="Link target outside of Sample"><b>5. R<span class="small">AY</span> A<span class="small">NDRADE</span>: T<span class="small">HE</span> D<span class="small">EVIL</span> D<span class="small">RIVES</span></b></span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix. Records</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3ebb1445